import React from "react";

import "./index.css";

import styled from "@emotion/styled";
import { HomeLayout } from "components/HomeLayout/HomeLayout";
import { Spacer } from "../../components/general/Spacer/Spacer";
import { Intro } from "./Intro/Intro";
import { Feature1 } from "./features/Feature1";
import { Feature2 } from "./features/Feature2";
import { Feature3 } from "./features/Feature3";
import { Feature4 } from "./features/Feature4";
import { SectionF } from "./features/SectionF";
import { SectionH } from "./features/SectionH";

/**
 * Home Page component. Houses the Layout and the sections.
 */
const Home: React.FC = () => {
  return (
    <Container>
      <HomeLayout>
        <ContentWrapper className="welcome">
          <Intro />
          <Spacer height="120px" />
          <Feature1 className="feature1-section" />
          <Feature2 className="feature2-section" />
          <Feature3 className="feature3-section" />
          <Feature4 className="feature4-section" />
          <SectionF />
          <SectionH />
        </ContentWrapper>
      </HomeLayout>
    </Container>
  );
};

export default Home;

// Sub-components

const Container = styled.div`
  background-color: ${props => props.theme.theme["200"]};
`;

const ContentWrapper = styled.div`
  backdrop-filter: blur(8px);
  position: relative;
  height: inherit;
  min-height: 100vh;
  margin-top: 218px;
`;
